import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { IconButton } from '@swift-paypal/pp-react-icon-button';
import { CloseIcon } from '@swift-paypal/pp-react-icons';
import ReactDOM from 'react-dom';
import { FocusOn } from 'react-focus-on';
import clsx from 'clsx';
import '../__generated__/styles/modal.css';

var styles = {"ppvx_modal--container_middle":"ppvx_modal--container_middle___2-7-4","ppvx_modal--container_bottom":"ppvx_modal--container_bottom___2-7-4","ppvx_modal":"ppvx_modal___2-7-4","ppvx_modal--overpanel":"ppvx_modal--overpanel___2-7-4","ppvx_modal--sheet":"ppvx_modal--sheet___2-7-4","ppvx_modal-backdrop":"ppvx_modal-backdrop___2-7-4","ppvx_modal-backdrop--show":"ppvx_modal-backdrop--show___2-7-4","ppvx_scrim":"ppvx_scrim___2-7-4","ppvx_scrim--show":"ppvx_scrim--show___2-7-4","ppvx_modal__contents":"ppvx_modal__contents___2-7-4","ppvx_modal-header":"ppvx_modal-header___2-7-4","ppvx_modal__contents--no-padding":"ppvx_modal__contents--no-padding___2-7-4","ppvx_modal__contents--center":"ppvx_modal__contents--center___2-7-4","ppvx_modal__screenreader":"ppvx_modal__screenreader___2-7-4","ppvx_modal-header__close":"ppvx_modal-header__close___2-7-4","ppvx_modal-header__action":"ppvx_modal-header__action___2-7-4","ppvx_modal-header--gripper":"ppvx_modal-header--gripper___2-7-4","ppvx_modal-header--divider":"ppvx_modal-header--divider___2-7-4","ppvx_modal-header--scrolled":"ppvx_modal-header--scrolled___2-7-4","ppvx_modal-header__title":"ppvx_modal-header__title___2-7-4","ppvx_modal-header__work-area":"ppvx_modal-header__work-area___2-7-4","ppvx_modal__contents--close":"ppvx_modal__contents--close___2-7-4","ppvx_modal-header__close-btn":"ppvx_modal-header__close-btn___2-7-4","ppvx_modal-content__title":"ppvx_modal-content__title___2-7-4","ppvx_modal-header--no-logo":"ppvx_modal-header--no-logo___2-7-4","ppvx_modal-footer":"ppvx_modal-footer___2-7-4","ppvx_modal-footer--scrolled":"ppvx_modal-footer--scrolled___2-7-4","ppvx_modal-footer--align_center":"ppvx_modal-footer--align_center___2-7-4","ppvx_modal-footer--align_right":"ppvx_modal-footer--align_right___2-7-4","ppvx_visible-only-in-context":"ppvx_visible-only-in-context___2-7-4","ppvx_modal--sheet--height_90":"ppvx_modal--sheet--height_90___2-7-4","ppvx_modal-header__close-btn--svg":"ppvx_modal-header__close-btn--svg___2-7-4","ppvx--v2":"ppvx--v2___2-7-4","ppvx--v1":"ppvx--v1___2-7-4"};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var uniqueId = function () {
  return (Math.random() * 100000000).toFixed(0).toString();
};

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  /* istanbul ignore next */
  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "closeButton", void 0);

    _defineProperty(_assertThisInitialized(_this), "contentRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "modalRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "idBase", void 0);

    _defineProperty(_assertThisInitialized(_this), "scrollChecker", function () {
      return _this.scrollCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "setFixedHeight", function () {
      var fixedHeight = window.innerHeight; //100vh

      var modalEl = _this.modalRef.current;

      if (modalEl) {
        if (_this.props.overpanel) {
          modalEl.style.height = "".concat(fixedHeight, "px");
        } else {
          modalEl.style.maxHeight = "".concat(fixedHeight, "px");
        }
      }
    });

    _this.closeButton = React.createRef();
    _this.contentRef = React.createRef();
    _this.modalRef = React.createRef();
    _this.idBase = props.id || uniqueId();
    _this.state = {
      isMounted: false,
      headerScroll: false,
      footerScroll: false
    };
    return _this;
  }
  /* istanbul ignore next */


  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        isMounted: true
      });
      var isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints;

      if (isTouchDevice && window.innerHeight) {
        this.setFixedHeight();
        window.addEventListener('resize', this.setFixedHeight, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setFixedHeight);
    } // jest has no way to test things like scrollTop or scrollHeight --BCC

    /* istanbul ignore next */

  }, {
    key: "scrollCheck",
    value: function scrollCheck() {
      if (this.contentRef && this.contentRef.current) {
        var contents = this.contentRef.current; // let needFocus = false

        var newState = null;
        var headerScroll = contents.scrollTop !== 0;

        if (headerScroll !== this.state.headerScroll) {
          newState = {
            headerScroll: headerScroll
          };
        } // Footer is optional, may not be one to watch for!


        if (this.props.footerContents) {
          // Have we scrolled to the bottom
          var footerScroll = contents.scrollTop + contents.offsetHeight !== contents.scrollHeight;

          if (footerScroll !== this.state.footerScroll) {
            newState = _objectSpread(_objectSpread({}, newState || {}), {}, {
              footerScroll: footerScroll
            });
          }
        }

        if (newState) {
          this.setState(newState);
        }
      }
    }
    /* istanbul ignore next */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // We need to set the focus ONLY when the next state
      // is open and the current state is not.
      var shouldSetFocus = this.props.isOpen && !prevProps.isOpen;

      if (this.props.isOpen) {
        this.scrollCheck();
      }

      var isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints;
      /* istanbul ignore next */

      if (isTouchDevice && window.innerHeight) {
        this.setFixedHeight();
      } // Skip this if rendering server-side

      /* istanbul ignore next */


      if (window && window.setTimeout) {
        // HACK ALERT! react-on-focus fails at setting the focus
        // if we are transitioning opacity. This causes the lightbox
        // to set the focus on the close button but NOT indicate
        // that fact to the user either visually or in the screen reader
        // So I had to handle that case on a timeout --love, BCC
        if (shouldSetFocus && this.props.isOpen && this.closeButton.current) {
          // Store the close button as a local for the closure
          var closeButton = this.closeButton.current;
          window.setTimeout(function () {
            /* istanbul ignore next */
            closeButton.focus();
          }, 100);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _clsx4, _clsx5;

      var _this$props = this.props,
          children = _this$props.children,
          onClose = _this$props.onClose,
          className = _this$props.className,
          _this$props$closeButt = _this$props.closeButtonLabel,
          closeButtonLabel = _this$props$closeButt === void 0 ? 'close modal' : _this$props$closeButt,
          isOpen = _this$props.isOpen,
          hideLogo = _this$props.hideLogo,
          hideTitle = _this$props.hideTitle,
          title = _this$props.title,
          _this$props$closeOnBa = _this$props.closeOnBackgroundClick,
          closeOnBackgroundClick = _this$props$closeOnBa === void 0 ? true : _this$props$closeOnBa,
          _this$props$action = _this$props.action,
          action = _this$props$action === void 0 ? null : _this$props$action,
          _this$props$footerCon = _this$props.footerContents,
          footerContents = _this$props$footerCon === void 0 ? null : _this$props$footerCon,
          footerAlign = _this$props.footerAlign,
          overpanel = _this$props.overpanel,
          center = _this$props.center,
          containerRef = _this$props.containerRef,
          headerClassName = _this$props.headerClassName,
          contentClassName = _this$props.contentClassName,
          footerClassName = _this$props.footerClassName,
          rest = _objectWithoutProperties(_this$props, ["children", "onClose", "className", "closeButtonLabel", "isOpen", "hideLogo", "hideTitle", "title", "closeOnBackgroundClick", "action", "footerContents", "footerAlign", "overpanel", "center", "containerRef", "headerClassName", "contentClassName", "footerClassName"]);

      var classes = clsx(styles.ppvx_modal, _defineProperty({}, styles['ppvx_modal--overpanel'], overpanel), className);
      var contentClasses = clsx(styles.ppvx_modal__contents, _defineProperty({}, styles['ppvx_modal__contents--center'], center), contentClassName);
      var ariaHidden = isOpen === true ? 'false' : 'true';
      var closeButton = /*#__PURE__*/React.createElement(IconButton, {
        svgIconComponent: CloseIcon,
        "aria-haspopup": "dialog",
        tabIndex: 0,
        onClick: onClose,
        className: styles['ppvx_modal-header__close-btn--svg'],
        ref: this.closeButton
      }, closeButtonLabel);

      var handleEscape = function (evt) {
        evt.preventDefault();
        onClose(evt);
      };

      var handleBackdropClick = function (evt) {
        if (closeOnBackgroundClick) {
          onClose(evt);
        }
      };

      var titleId = "header_".concat(this.idBase);
      var titleElement = null;
      var ariaProps = {
        role: 'dialog',
        className: clsx(styles['ppvx_modal-backdrop'], _defineProperty({}, styles['ppvx_modal-backdrop--show'], isOpen)),
        'aria-modal': 'true',
        'aria-hidden': ariaHidden
      };

      if (hideTitle) {
        // @ts-ignore
        ariaProps['aria-label'] = title;
      } else {
        // @ts-ignore
        ariaProps['aria-labelledby'] = titleId;
        titleElement = /*#__PURE__*/React.createElement("h2", {
          id: titleId
        }, title);
      }

      var footer = footerContents ? /*#__PURE__*/React.createElement("footer", {
        className: clsx(styles['ppvx_modal-footer'], (_clsx4 = {}, _defineProperty(_clsx4, styles['ppvx_modal-footer--scrolled'], this.state.footerScroll), _defineProperty(_clsx4, styles["ppvx_modal-footer--align_".concat(footerAlign)], footerAlign), _clsx4), footerClassName)
      }, footerContents) : null;
      var focusClass = overpanel ? 'ppvx_modal--container_bottom' : 'ppvx_modal--container_middle';
      var contents = /*#__PURE__*/React.createElement("div", ariaProps, isOpen && /*#__PURE__*/React.createElement(FocusOn, {
        enabled: !!isOpen // @ts-ignore: onEscapeKey() wants an Event, but the rest of this code wants SyntheticEvent<>
        ,
        onEscapeKey: function onEscapeKey(evt) {
          return handleEscape(evt);
        },
        onClickOutside: function onClickOutside() {
          return handleBackdropClick();
        },
        className: styles[focusClass]
      }, /*#__PURE__*/React.createElement("article", _extends({
        className: classes
      }, rest, {
        ref: this.modalRef
      }), /*#__PURE__*/React.createElement("header", {
        className: clsx(styles['ppvx_modal-header'], (_clsx5 = {}, _defineProperty(_clsx5, styles['ppvx_modal-header--no-logo'], hideLogo), _defineProperty(_clsx5, styles['ppvx_modal-header--scrolled'], this.state.headerScroll), _clsx5), headerClassName)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['ppvx_modal-header__action']
      }, action), /*#__PURE__*/React.createElement("div", {
        className: styles['ppvx_modal-header__close']
      }, closeButton)), /*#__PURE__*/React.createElement("section", {
        className: contentClasses,
        onScroll: this.scrollChecker,
        ref: this.contentRef
      }, titleElement, children), footer)));
      var containerElm = containerRef && containerRef.current; // Delay createPortal until component is mounted to fix server side rendering

      return this.state.isMounted && ReactDOM.createPortal(contents, containerElm || document.body);
    }
  }]);

  return Modal;
}(React.Component);

export { Modal };
